import Component from './TwitterPostTable.vue'
export default Component
